module.exports = __webpack_public_path__ + "static/media/cisco-leaderboard.e69b9e16.png";